import { Box, Link } from "@mui/material";
import { useLocales } from "../../../locales";
import { CommonWrap, ComomonAlert } from "../../common";
import Table from "../../../DocLayout/Table";
import CodeSnippet from "../../../components/CodeSnippet";
import ContentWrap from "../../../DocLayout/Content/Index";
import {
  APP_DEPOSIT__RECORD,
  APP_DEPOSIT__RECORD_LIST,
  APP_ORDERRECORD,
  CREATE_APP_AORDER_EPOSIT_ADDRESS,
  CREATE_APP_DEPOSIT__ADDRESS,
  TELEGRAM_SUPPORT_URL,
} from "../../../config";
import { Trans } from "react-i18next";
import { useContext } from "react";
import { ChooseCodeLanguageContext } from "@/components/ChooseCodeLanguage/ChooseCodeLanguage";
import { codeMap } from "@/PageCodeComponents/MerchantAPPModelAPI";
import PostRequest from "@/components/PostRequest";
export default function Index() {
  const { translate, currentLang } = useLocales();
  const { language } = useContext(ChooseCodeLanguageContext);

  return (
    <div>
      {/* 创建订单收款地址  充值相关API*/}
      <ContentWrap
        id="deposit-apis"
        showBorderBottom={false}
        leftChildren={
          <CommonWrap>
            <Box className="title_0" id="create-deposit-address-for-order">
              {translate("merchant_app_mode_API.text_8")}
            </Box>
            <Box className="title_1">
              {translate("merchant_app_mode_API.text_9")}
            </Box>
            <Box className="desc">
              {translate("merchant_app_mode_API.text_10")}
            </Box>
            <Box className="desc">
              {translate("merchant_app_mode_API.text_11")}
            </Box>
            <Box mt={3} className="title_1">
              {translate("common.http_request")}
            </Box>
            <Box className="desc link">
              <PostRequest url={CREATE_APP_AORDER_EPOSIT_ADDRESS} />
            </Box>
            <Box mt={3} className="title_1">
              {translate("common.http_params")}
            </Box>
            <Table
              tableData={[
                {
                  name: "coinId",
                  type: "Integer",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate("merchant_app_mode_API.text_12")}`,
                },
                {
                  name: "fiatId",
                  type: "Integer",
                  is_: `${translate("common.params_no")}`,
                  desc:
                    currentLang?.value === "en" ? (
                      <div>
                        <span
                          dangerouslySetInnerHTML={{
                            __html: `${translate(
                              "merchant_app_mode_API.text_13"
                            )} ` as any,
                          }}
                        />
                        <Trans
                          i18nKey={"merchant_app_mode_API.text_13_"}
                          t={translate as any}
                        >
                          s
                          <a href={"#get-fiat-list"} className="link">
                            Just a placeholder
                          </a>
                        </Trans>
                      </div>
                    ) : (
                      <div>
                        <span
                          dangerouslySetInnerHTML={{
                            __html: `${translate(
                              "merchant_app_mode_API.text_13"
                            )} ` as any,
                          }}
                        />
                        <Trans
                          i18nKey={"merchant_app_mode_API.text_13_"}
                          t={translate as any}
                        >
                          s
                          <a href={"#get-fiat-list"} className="link">
                            Just a placeholder
                          </a>
                        </Trans>
                        <span
                          dangerouslySetInnerHTML={{
                            __html: `${translate(
                              "merchant_app_mode_API.text_13_1"
                            )} ` as any,
                          }}
                        />
                      </div>
                    ),
                },
                {
                  name: "price",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: `${translate(
                          "merchant_app_mode_API.text_14"
                        )} ` as any,
                      }}
                    />
                  ),
                },
                {
                  name: "chain",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate("merchant_user_wallet_mode_API.text_3")}`,
                },
                {
                  name: "orderId",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate("merchant_user_wallet_mode_API.text_44")}`,
                },
                {
                  name: "expiredAt",
                  type: "Integer",
                  is_: `${translate("common.params_no")}`,
                  desc: (
                    <Trans
                      i18nKey={"merchant_app_mode_API.text_16"}
                      t={translate as any}
                    >
                      s<strong>s</strong>
                      <strong>s</strong>
                      <strong>s</strong>s
                    </Trans>
                  ),
                },
                {
                  name: "buyerEmail",
                  type: "String",
                  is_: `${translate("common.params_no")}`,
                  desc: `${translate("merchant_app_mode_API.text_17")}`,
                },
                {
                  name: "generateCheckoutURL",
                  type: "Boolean",
                  is_: `${translate("common.params_no")}`,
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: `${translate(
                          "merchant_app_mode_API.text_18"
                        )} ` as any,
                      }}
                    />
                  ),
                },
                {
                  name: "product",
                  type: "String",
                  is_: `${translate("common.params_no")}`,
                  desc: `${translate("merchant_app_mode_API.text_19")}`,
                },
                {
                  name: "returnUrl",
                  type: "String",
                  is_: `${translate("common.params_no")}`,
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: `${translate(
                          "merchant_app_mode_API.text_20"
                        )} ` as any,
                      }}
                    />
                  ),
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_request_ex")}
            code={codeMap["app_order_deposit_address"][language].http_ex_code}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* 创建订单收款地址 返回*/}
      <ContentWrap
        leftChildren={
          <CommonWrap>
            <Box className="title_1">{translate("common.http_res")}</Box>
            <Table
              res
              tableData={[
                {
                  name: "data",
                  type: "Object",
                  desc: "",
                },
                {
                  name: "data.amountToPay",
                  type: "String",
                  desc: `${translate("merchant_app_mode_API.text_21")}`,
                },
                {
                  name: "data.address",
                  type: "String",
                  desc: `${translate("merchant_app_mode_API.text_22")}`,
                },
                {
                  name: "data.memo",
                  type: "String",
                  desc: `${translate("merchant_app_mode_API.text_23")}`,
                },
                {
                  name: "data.checkoutUrl",
                  type: "String",
                  desc: `${translate("merchant_app_mode_API.text_24")}`,
                },
                {
                  name: "data.confirmsNeeded",
                  type: "Integer",
                  desc: `${translate("merchant_app_mode_API.text_25")}`,
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_result")}
            code={codeMap["app_order_deposit_address"].response}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* Webhook 通知 - API Deposit */}
      <ContentWrap
        id="webhook-for-api-deposit"
        leftChildren={
          <CommonWrap>
            <Box className="title_1">
              {translate("merchant_app_mode_API.text_27")}
            </Box>

            <Box component={"div"} className="desc">
              <Trans
                i18nKey={"merchant_app_mode_API.text_28"}
                t={translate as any}
              >
                Just a placeholder
                <a href={"#get-order-information"} className="link">
                  Just a placeholder
                </a>
              </Trans>
            </Box>

            <Box mt={3} className="title_1">
              {translate("merchant_user_wallet_mode_API.text_49")}
            </Box>
            <Table
              res
              tableData={[
                {
                  name: "recordId",
                  type: "String",
                  desc: translate("merchant_user_wallet_mode_API.text_14"),
                },
                {
                  name: "orderId",
                  type: "String",
                  desc: `${translate("merchant_app_mode_API.text_29")}`,
                },
                {
                  name: "coinId",
                  type: "Integer",
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.response_coin_id"
                  )}`,
                },
                {
                  name: "coinSymbol",
                  type: "String",
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.response_coin_symbol"
                  )}`,
                },
                {
                  name: "status",
                  type: "String",
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_user_wallet_mode_API.text_9"
                        ) as any,
                      }}
                    />
                  ),
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_request_ex")}
            code={`{
  "type": "ApiDeposit",
  "msg": {
    "recordId": "20240313121919...",
    "orderId": "202403131218361...",
    "coinId": 1329,
    "coinSymbol": "MATIC",
    "status": "Success"
  }
}`}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* 获取充值订单信息 */}
      <ContentWrap
        id="get-order-information"
        showBorderBottom={false}
        leftChildren={
          <CommonWrap>
            <Box className="title_1">
              {translate("merchant_app_mode_API.text_30")}
            </Box>

            <Box component={"div"} className="desc">
              {translate("merchant_app_mode_API.text_31")}
            </Box>

            <Box mt={3} className="title_1">
              {translate("common.http_request")}
            </Box>
            <Box className="desc link">
              <PostRequest url={APP_ORDERRECORD} />
            </Box>
            <Box mt={3} className="title_1">
              {translate("common.http_params")}
            </Box>
            <Table
              tableData={[
                {
                  name: "orderId",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate("merchant_app_mode_API.text_88")}`,
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_request_ex")}
            code={codeMap["app_order_info"][language].http_ex_code}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />

      {/* 获取充值订单信息 返回 */}
      <ContentWrap
        leftChildren={
          <CommonWrap>
            <Box className="title_1">{translate("common.http_res")}</Box>
            <Table
              res
              tableData={[
                {
                  name: "data",
                  type: "Object",
                  desc: ``,
                },
                {
                  name: "data.amountToPay",
                  type: "String",
                  desc: `${translate("merchant_app_mode_API.text_21")}`,
                },
                {
                  name: "data.coinId",
                  type: "Integer",
                  desc: `${translate("merchant_app_mode_API.text_32")}`,
                },
                {
                  name: "data.coinSymbol",
                  type: "String",
                  desc: `${translate("merchant_app_mode_API.text_33")}`,
                },
                {
                  name: "data.chain",
                  type: "String",
                  desc: `${translate("merchant_app_mode_API.text_34")}`,
                },
                {
                  name: "data.toAddress",
                  type: "String",
                  desc: `${translate("merchant_app_mode_API.text_35")}`,
                },
                {
                  name: "data.toMemo",
                  type: "String",
                  desc: `${translate("merchant_app_mode_API.text_36")}`,
                },
                {
                  name: "data.fiatId",
                  type: "Integer",
                  desc: `${translate("merchant_app_mode_API.text_37")}`,
                },
                {
                  name: "data.fiatSymbol",
                  type: "String",
                  desc: `${translate("merchant_app_mode_API.text_38")}`,
                },
                {
                  name: "data.rate",
                  type: "String",
                  desc: `${translate("merchant_app_mode_API.text_39")}`,
                },
                {
                  name: "data.createAt",
                  type: "Integer",
                  desc: `${translate("merchant_app_mode_API.text_40")}`,
                },
                {
                  name: "data.expiredAt",
                  type: "Integer",
                  desc: (
                    <Trans
                      i18nKey={"merchant_app_mode_API.text_41"}
                      t={translate as any}
                    >
                      s<strong>s</strong>
                      <strong>s</strong>
                      <strong>s</strong>s
                    </Trans>
                  ),
                },
                {
                  name: "data.checkoutUrl",
                  type: "String",
                  desc: `${translate("merchant_app_mode_API.text_42")}`,
                },

                {
                  name: "data.buyerEmail",
                  type: "String",
                  desc: `${translate("merchant_app_mode_API.text_43")}`,
                },

                {
                  name: "data.paidList",
                  type: "Array",
                  desc: `${translate("merchant_app_mode_API.text_44")}`,
                },
                {
                  name: "data.paidList[index].recordId",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_14")}`,
                },
                {
                  name: "data.paidList[index].fromAddress",
                  type: "String",
                  desc: `${translate("merchant_app_mode_API.text_45")}`,
                },
                {
                  name: "data.paidList[index].amount",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_20")}`,
                },
                {
                  name: "data.paidList[index].serviceFee",
                  type: "String",
                  desc: `${translate("merchant_app_mode_API.text_46")}`,
                },
                {
                  name: "data.paidList[index].txid",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_22")}`,
                },
                {
                  name: "data.paidList[index].status",
                  type: "String",
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: `${translate(
                          "merchant_app_mode_API.text_15"
                        )} ` as any,
                      }}
                    />
                  ),
                },
                {
                  name: "data.paidList[index].arrivedAt",
                  type: "Integer",
                  desc: `${translate("merchant_app_mode_API.text_47")}`,
                },
                {
                  name: "data.paidList[index].rate",
                  type: "String",
                  desc: (
                    <div
                      className="code"
                      dangerouslySetInnerHTML={{
                        __html: `${translate(
                          "merchant_app_mode_API.text_48"
                        )} ` as any,
                      }}
                    />
                  ),
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_result")}
            code={codeMap["app_order_info"].response}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* 创建或获取永久收款地址 */}
      <ContentWrap
        id="get-permanent-deposit-address"
        showBorderBottom={false}
        leftChildren={
          <CommonWrap>
            <Box className="title_0">
              {translate("merchant_app_mode_API.text_49")}
            </Box>
            <Box className="desc">
              <div
                className="code"
                dangerouslySetInnerHTML={{
                  __html: `${translate(
                    "merchant_app_mode_API.text_50"
                  )} ` as any,
                }}
              />
            </Box>
            {currentLang?.value === "en" ? (
              <Box>
                <Box className="desc">
                  {translate("merchant_app_mode_API.text_89")}
                </Box>
                <Box
                  sx={{
                    ul: {
                      paddingLeft: "2em",
                    },
                    li: {
                      "::marker": {
                        textIndent: "2em",
                      },
                    },
                  }}
                >
                  <ul>
                    <li>
                      <Box component={"div"} className="desc">
                        {translate("merchant_app_mode_API.text_90")}
                      </Box>
                    </li>
                    <li>
                      <Box component={"div"} className="desc">
                        {translate("merchant_app_mode_API.text_91")}
                      </Box>
                    </li>
                  </ul>
                  <Box component={"div"} className="desc">
                    <Trans
                      i18nKey={"merchant_app_mode_API.text_91_"}
                      t={translate as any}
                    >
                      Just a placeholder
                      <Link
                        href={TELEGRAM_SUPPORT_URL}
                        target="_blank"
                        className="link"
                        underline="always"
                      >
                        Just a placeholder
                      </Link>
                    </Trans>
                  </Box>
                </Box>
              </Box>
            ) : (
              <Box>
                <Box className="desc">
                  {translate("merchant_app_mode_API.text_51")}
                </Box>
                <Box component={"div"} className="desc">
                  <Trans
                    i18nKey={"merchant_app_mode_API.text_51_"}
                    t={translate as any}
                  >
                    Just a placeholder
                    <Link
                      href={TELEGRAM_SUPPORT_URL}
                      target="_blank"
                      className="link"
                      underline="always"
                    >
                      Just a placeholder
                    </Link>
                  </Trans>
                </Box>
              </Box>
            )}

            <Box mt={3} className="title_1">
              {translate("common.http_request")}
            </Box>
            <Box className="desc link">
              <PostRequest url={CREATE_APP_DEPOSIT__ADDRESS} />
            </Box>
            <Box mt={3} className="title_1">
              {translate("common.http_params")}
            </Box>
            <Table
              tableData={[
                {
                  name: "referenceId",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate("merchant_app_mode_API.text_87")}`,
                },
                {
                  name: "chain",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate("merchant_user_wallet_mode_API.text_3")}`,
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_request_ex")}
            code={
              codeMap["or_create_app_deposit_address"][language].http_ex_code
            }
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* 创建或获取永久收款地址 返回 */}
      <ContentWrap
        leftChildren={
          <CommonWrap>
            <Box className="title_1">{translate("common.http_res")}</Box>
            <Table
              res
              tableData={[
                {
                  name: "data",
                  type: "Object",
                  desc: ``,
                },
                {
                  name: "data.address",
                  type: "String",
                  desc: translate("merchant_app_mode_API.text_52"),
                },
                {
                  name: "data.memo",
                  type: "String",
                  desc: translate("merchant_app_mode_API.text_53"),
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_result")}
            code={codeMap["or_create_app_deposit_address"].response}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* Webhook 通知 - Direct Deposit */}
      <ContentWrap
        id="webhook-for-direct-deposit"
        leftChildren={
          <CommonWrap>
            <Box className="title_1">
              {translate("merchant_app_mode_API.text_54")}
            </Box>

            <Box component={"div"} className="desc">
              <Trans
                i18nKey={"merchant_app_mode_API.text_55"}
                t={translate as any}
              >
                Just a placeholder
                <a href={"#get-deposit-record"} className="link">
                  Just a placeholder
                </a>
              </Trans>
            </Box>

            <Box mt={3} className="title_1">
              {translate("merchant_user_wallet_mode_API.text_49")}
            </Box>
            <Table
              res
              tableData={[
                {
                  name: "recordId",
                  type: "String",
                  desc: translate("merchant_user_wallet_mode_API.text_14"),
                },
                {
                  name: "referenceId",
                  type: "String",
                  desc: `${translate("merchant_app_mode_API.text_56")}`,
                },
                {
                  name: "coinId",
                  type: "Integer",
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.response_coin_id"
                  )}`,
                },
                {
                  name: "coinSymbol",
                  type: "String",
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.response_coin_symbol"
                  )}`,
                },
                {
                  name: "status",
                  type: "String",
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_user_wallet_mode_API.text_9"
                        ) as any,
                      }}
                    />
                  ),
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_request_ex")}
            code={`{
  "type": "DirectDeposit",
  "msg": {
    "recordId": "2024031311310811...",
    "referenceId": "63224704901...",
    "coinId": 1329,
    "coinSymbol": "MATIC",
    "status": "Success"
  }
}`}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* 获取充值记录 */}
      <ContentWrap
        id="get-deposit-record"
        showBorderBottom={false}
        leftChildren={
          <CommonWrap>
            <Box className="title_1">
              {translate("merchant_app_mode_API.text_57")}
            </Box>
            <Box className="desc code">
              {translate("merchant_app_mode_API.text_58")}
            </Box>
            <Box mt={3} className="title_1">
              {translate("common.http_request")}
            </Box>
            <Box className="desc link">
              <PostRequest url={APP_DEPOSIT__RECORD} />
            </Box>
            <Box mt={3} className="title_1">
              {translate("common.http_params")}
            </Box>
            <Table
              tableData={[
                {
                  name: "recordId",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: translate("merchant_user_wallet_mode_API.text_14"),
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_request_ex")}
            code={codeMap["deposit_record"][language].http_ex_code}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* 获取充值记录 返回 */}
      <ContentWrap
        leftChildren={
          <CommonWrap>
            <Box className="title_1">{translate("common.http_res")}</Box>
            <Table
              res
              tableData={[
                {
                  name: "data",
                  type: "Object",
                  desc: ``,
                },
                {
                  name: "data.record",
                  type: "Object",
                  desc: "",
                },
                {
                  name: "data.record.recordId",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_14")}`,
                },
                {
                  name: "data.record.coinId",
                  type: "Integer",
                  desc: `${translate("merchant_user_wallet_mode_API.text_34")}`,
                },
                {
                  name: "data.record.coinSymbol",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_35")}`,
                },
                {
                  name: "data.record.chain",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_36")}`,
                },
                {
                  name: "data.reocrd.contract",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_37")}`,
                },
                {
                  name: "data.record.fromAddress",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_17")}`,
                },
                {
                  name: "data.record.toAddress",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_18")}`,
                },
                {
                  name: "data.record.toMemo",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_19")}`,
                },
                {
                  name: "data.record.amount",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_20")}`,
                },
                {
                  name: "data.record.serviceFee",
                  type: "String",
                  desc: `${translate("merchant_app_mode_API.text_46")}`,
                },
                {
                  name: "data.record.txId",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_22")}`,
                },
                {
                  name: "data.record.status",
                  type: "String",
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_user_wallet_mode_API.text_23"
                        ) as any,
                      }}
                    />
                  ),
                },
                {
                  name: "data.record.arrivedAt",
                  type: "Integer",
                  desc: `${translate("merchant_user_wallet_mode_API.text_24")}`,
                },
                {
                  name: "data.record.referenceId",
                  type: "String",
                  desc: `${translate("merchant_app_mode_API.text_59")}`,
                },
                {
                  name: "data.record.orderId",
                  type: "String",
                  desc: `${translate("merchant_app_mode_API.text_60")}`,
                },
              ]}
            />
            <ComomonAlert sx={{ mt: 2 }}>
              <div
                className="code"
                dangerouslySetInnerHTML={{
                  __html: translate(
                    "merchant_user_wallet_mode_API.text_96"
                  ) as any,
                }}
              />
            </ComomonAlert>
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_result")}
            code={codeMap["deposit_record"].response}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />

      {/* 获取充值记录列表 Get Deposit Record List */}
      <ContentWrap
        id="get-deposit-record-list"
        showBorderBottom={false}
        leftChildren={
          <CommonWrap>
            <Box className="title_0">
              {translate("merchant_app_mode_API.text_61")}
            </Box>
            <Box className="desc">
              {translate("merchant_app_mode_API.text_62")}
            </Box>
            <Box mt={3} className="title_1">
              {translate("common.http_request")}
            </Box>
            <Box className="desc link">
              <PostRequest url={APP_DEPOSIT__RECORD_LIST} />
            </Box>
            <Box mt={3} className="title_1">
              {translate("common.http_params")}
            </Box>
            <Table
              tableData={[
                {
                  name: "coinId",
                  type: "Integer",
                  is_: `${translate("common.params_no")}`,
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.response_coin_id"
                  )}`,
                },
                {
                  name: "referenceId",
                  type: "String",
                  is_: `${translate("common.params_no")}`,
                  desc: `${translate("merchant_app_mode_API.text_87")}`,
                },
                {
                  name: "orderId",
                  type: "String",
                  is_: `${translate("common.params_no")}`,
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_app_mode_API.text_64"
                        ) as any,
                      }}
                    />
                  ),
                },
                {
                  name: "chain",
                  type: "String",
                  is_: `${translate("common.params_no")}`,
                  desc: `${translate("merchant_user_wallet_mode_API.text_3")}`,
                },

                {
                  name: "startAt",
                  type: "Integer",
                  is_: `${translate("common.params_no")}`,
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_user_wallet_mode_API.text_28"
                        ) as any,
                      }}
                    />
                  ),
                },
                {
                  name: "endAt",
                  type: "Integer",
                  is_: `${translate("common.params_no")}`,
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_user_wallet_mode_API.text_29"
                        ) as any,
                      }}
                    />
                  ),
                },
                {
                  name: "nextId",
                  type: "String",
                  is_: `${translate("common.params_no")}`,
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_user_wallet_mode_API.text_30"
                        ) as any,
                      }}
                    />
                  ),
                },
              ]}
            />
            <ComomonAlert sx={{ mt: 2 }}>
              <div
                className="code"
                dangerouslySetInnerHTML={{
                  __html: translate(
                    `merchant_user_wallet_mode_API.${
                      currentLang?.value === "en" ? "text_32" : "text_31"
                    }`
                  ) as any,
                }}
              />
            </ComomonAlert>
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_request_ex")}
            code={codeMap["deposit_record_list"][language].http_ex_code}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* 获取充值记录列表  返回*/}
      <ContentWrap
        leftChildren={
          <CommonWrap>
            <Box className="title_1">{translate("common.http_res")}</Box>
            <Table
              res
              tableData={[
                {
                  name: "data",
                  type: "Object",
                  desc: ``,
                },
                {
                  name: "data.records",
                  type: "Array",
                  desc: "",
                },
                {
                  name: "data.records[index].recordId",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_14")}`,
                },
                {
                  name: "data.records[index].coinId",
                  type: "Integer",
                  desc: `${translate("merchant_user_wallet_mode_API.text_34")}`,
                },
                {
                  name: "data.records[index].coinSymbol",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_35")}`,
                },
                {
                  name: "data.records[index].chain",
                  type: "String",
                  desc: `${translate("merchant_app_mode_API.text_65")}`,
                },
                {
                  name: "data.records[index].fromAddress",
                  type: "String",
                  desc: `${translate("merchant_app_mode_API.text_45")}`,
                },
                {
                  name: "data.records[index].toAddress",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_18")}`,
                },
                {
                  name: "data.records[index].toMemo",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_19")}`,
                },
                {
                  name: "data.records[index].amount",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_20")}`,
                },
                {
                  name: "data.records[index].serviceFee",
                  type: "String",
                  desc: `${translate("merchant_app_mode_API.text_46")}`,
                },
                {
                  name: "data.records[index].txId",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_22")}`,
                },
                {
                  name: "data.records[index].status",
                  type: "String",
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_user_wallet_mode_API.text_23"
                        ) as any,
                      }}
                    />
                  ),
                },
                {
                  name: "data.records[index].arrivedAt",
                  type: "Integer",
                  desc: `${translate("merchant_app_mode_API.text_47")}`,
                },
                {
                  name: "data.records[index].referenceId",
                  type: "String",
                  desc: `${translate("merchant_app_mode_API.text_59")}`,
                },
                {
                  name: "data.records[index].orderId",
                  type: "String",
                  desc: `${translate("merchant_app_mode_API.text_60")}`,
                },
                {
                  name: "data.nextId",
                  type: "String",
                  desc: (
                    <div>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: `${translate(
                            `merchant_user_wallet_mode_API.${
                              currentLang?.value === "en"
                                ? "text_32"
                                : "text_30_"
                            }`
                          )}` as any,
                        }}
                      />
                    </div>
                  ),
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_result")}
            code={codeMap["deposit_record_list"].response}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
    </div>
  );
}
